module.exports = __webpack_public_path__ + "img/project-4.67940036.png";